
"use client"

import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import headerimage from "../../assets/images/ascas.svg"
import SinglePatientInfo from "../../Components/Global_Components/common/SinglePatientInfo"
import ReportFormInputWithLabel from "../../Components/Global_Components/form/ReportFormInputWithLabel"
import TemplateTable from "../../Components/Global_Components/TemplateTable/TemplateTable"
import Headers from "../../Components/Header/Headers"
import { PrescriptionFooter } from "../../Components/Prescription Footer/PrescriptionFooter"
import { fetchPatientDetailsUuid, postAppointment, postPrescriptionTemplate } from "../../Redux/Thunk/Actions"
import {
  bmiValue,
  handleNill,
  labelStyles,
  renderReportfield,
  renderTableTD,
  renderTableTH,
} from "../../utils/templateUtils"
import "./HRTChart.scss"

export default function HRTListChart(props) {
  const [formData, setFormData] = useState({})
  const [show, setshow] = useState(false)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const patientId = useSelector((state) => state.counter.patientid)
  const [appointmentData, setAppointmentData] = useState({
    p_uhid: "",
    name: "",
    date: "",
    time: "",
    status: "Not Visited",
    notes: "",
    patient_id: "",
  })

  const handleHrtRowsChange = (id, newRows) => {
    let changedIndex = -1;
    for (let i = 0; i < newRows.length; i++) {
      if (newRows[i].date !== hrtChartRows[i]?.date) {
        changedIndex = i;
        break;
      }
    }

    if (changedIndex !== -1 && newRows[changedIndex].date) {
      const updatedRows = [...newRows];
      let baseDate = new Date(newRows[changedIndex].date);
      for (let i = changedIndex + 1; i < updatedRows.length; i++) {
        let nextDate = new Date(baseDate);
        nextDate.setDate(baseDate.getDate() + (i - changedIndex));
        updatedRows[i] = {
          ...updatedRows[i],
          date: nextDate.toISOString().split("T")[0],
        };
      }
      setHrtChartRows(updatedRows);
    } else {
      setHrtChartRows(newRows);
    }
  };

  const handleStartDateChange = (e) => {
    const startDate = e.target.value;
    if (startDate) {
      setHrtChartRows((prevRows) => {
        const updatedRows = [...prevRows];
        let baseDate = new Date(startDate);
        for (let i = 0; i < updatedRows.length; i++) {
          let nextDate = new Date(baseDate);
          nextDate.setDate(baseDate.getDate() + i);
          updatedRows[i] = {
            ...updatedRows[i],
            date: nextDate.toISOString().split("T")[0],
          };
        }
        return updatedRows;
      });
    }
  };

  const medicationHeaders = [
    { key: "sno", label: "S.No" },
    { key: "medicine", label: "Medicine" },
    { key: "genericName", label: "Generic Name" },
    { key: "dose", label: "Dose" },
    { key: "frequency", label: "Frequency" },
    { key: "route", label: "Route" },
    { key: "duration", label: "Duration" },
    { key: "withFood", label: "With Food" },
  ]

  const [medicationRows, setMedicationRows] = useState([
    {
      sno: 1,
      medicine: "Tab. Progynova",
      genericName: "Estradiol Valerate",
      dose: "2 mg",
      frequency: "As advised",
      route: "Oral",
      duration: "-",
      withFood: "After Food",
    },
    {
      sno: 2,
      medicine: "Tab. Folvista",
      genericName: "L-Carnitine + Zinc + Folic Acid",
      dose: "1 tab",
      frequency: "1-0-0",
      route: "Oral",
      duration: "30 days",
      withFood: "After Food",
    },
    {
      sno: 3,
      medicine: "Tab. Ecosprin 75/150",
      genericName: "Aspirin 75/150 mg",
      dose: "1 tablet",
      frequency: "0-0-1",
      route: "Oral",
      duration: "30 days",
      withFood: "in the night after meal",
    },
    {
      sno: 4,
      medicine: "Argiprime Sachet",
      genericName: "L-Arginine",
      dose: "1 sachet",
      frequency: "1-0-0",
      route: "Oral",
      duration: "30 days",
      withFood: "After Food",
    },
    {
      sno: 5,
      medicine: "Tab. Tricium XT / Calcium (Generic)",
      genericName: "Calcium Carbonate + Vitamin D3",
      dose: "1 tab",
      frequency: "0-1-0",
      route: "Oral",
      duration: "30 days",
      withFood: "After Food",
    },
    {
      sno: 6,
      medicine: "Estogel",
      genericName: "Estradiol Gel",
      dose: "As advised",
      frequency: "-",
      route: "Over skin",
      duration: "-",
      withFood: "-",
    },
    {
      sno: 7,
      medicine: "Tab. Sildenafil",
      genericName: "Sildenafil Citrate",
      dose: "25/50 mg",
      frequency: "0-1-0",
      route: "Vaginal",
      duration: "From Day 5",
      withFood: "-",
    },
    {
      sno: 8,
      medicine: "T. C Vit / Celin",
      genericName: "Vitamin C",
      dose: "500 mg",
      frequency: "1-0-1",
      route: "Oral",
      duration: "30 days",
      withFood: "After Food",
    },
    {
      sno: 9,
      medicine: "T. Neuroplex / Neurobion",
      genericName: "Vitamin B-complex",
      dose: "1 tab",
      frequency: "OD",
      route: "Oral",
      duration: "30 days",
      withFood: "After Food",
    },
  ])

  const hrtChartHeaders = [
    { key: "date", label: "DATE", inputType: "date" },
    { key: "cd", label: "CD" },
    { key: "tabProgynova", label: "TAB. PROGYNOVA / EVATONE" },
    { key: "et", label: "ET" },
    { key: "r", label: "R" },
    { key: "zone", label: "ZONE" },
  ]

  const [hrtChartRows, setHrtChartRows] = useState([
    { sno: 1, date: "", cd: "CD-1", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 2, date: "", cd: "CD-2", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 3, date: "", cd: "CD-3", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 4, date: "", cd: "CD-4", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 5, date: "", cd: "CD-5", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 6, date: "", cd: "CD-6", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 7, date: "", cd: "CD-7", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 8, date: "", cd: "CD-8", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 9, date: "", cd: "CD-9", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 10, date: "", cd: "CD-10", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 11, date: "", cd: "CD-11", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 12, date: "", cd: "CD-12", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 13, date: "", cd: "CD-13", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 14, date: "", cd: "CD-14", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 15, date: "", cd: "CD-15", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 16, date: "", cd: "CD-16", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 17, date: "", cd: "CD-17", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 18, date: "", cd: "CD-18", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 19, date: "", cd: "CD-19", tabProgynova: "", et: "", r: "", zone: "" },
    { sno: 20, date: "", cd: "CD-20", tabProgynova: "", et: "", r: "", zone: "" },
  ])

  const scanHeaders = [
    { key: "etThickness", label: "ET Thickness" },
    { key: "rightOvary", label: "Right Ovary (Follicles)" },
    { key: "leftOvary", label: "Left Ovary (Follicles)" },
  ]

  const [scanRows, setScanRows] = useState([
    { etThickness: "", rightOvary: "", leftOvary: "" },
    { etThickness: "", rightOvary: "", leftOvary: "" },
    { etThickness: "", rightOvary: "", leftOvary: "" },
  ])

  const hormonalProfileHeaders = [
    { key: "hormone", label: "Hormone" },
    { key: "valueTestDate", label: "Value Test Date" },
  ]

  const [hormonalProfileRows, setHormonalProfileRows] = useState([
    { hormone: "Prolactin (PRL)", valueTestDate: "" },
    { hormone: "Estradiol (E2)", valueTestDate: "" },
    { hormone: "Progesterone (P4)", valueTestDate: "" },
    { hormone: "Thyroid (TSH)", valueTestDate: "" },
    { hormone: "HbA1c", valueTestDate: "" },
  ])

  const [showTables, setShowTables] = useState({
    medicationChart: true,
    hrtChart: true,
    scanTable: true,
    hormonalProfile: true,
  })

  const handleChange = (e) => {
    var text = e.target.value

    if (e.target.name === "patientId") {
      if (/^(ASCAS|VDASCAS)\d+$/i.test((e.target.value || "").trim())) {
        const fetchData = async () => {
          const payload = {
            p_uhid: e.target.value,
          }
          props.loaderchange("true")
          const addPatient = fetchPatientDetailsUuid(payload)
          const response = await dispatch(addPatient)
          if (response.payload?.status?.code === 200) {
            const data = response.payload.data.data[0]
            const namePat = data?.titles + " " + data?.first_name + " " + data?.last_name
            setFormData({
              ...formData,
              patientName: namePat,
              age: data?.age,
              gender: data?.gender,
              patientId: text,
            })
            props.loaderchange("false")
          } else {
            props.loaderchange("false")
            props.popupalert("true")
            props.popuptext("Network went wrong, Please try after some time.")
            setTimeout(() => {
              props.popupalert("false")
            }, 2000)
          }
          return
        }

        fetchData()
      } else {
        setFormData({
          ...formData,
          patientId: e.target.value,
        })
      }
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value })
      if (e.target.name === "nextappointment") {
        const dateTime = e.target.value.split("T")
        setAppointmentData({
          ...appointmentData,
          date: dateTime[0],
          time: dateTime[1],
          p_uhid: props.patientsData?.p_uhid || formData.patientId,
          name: props.patientsData?.titles
            ? `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`
            : formData.patientName,
          status: "Not Visited",
          notes: "Booking Visit",
          patient_id: patientId,
        })
      }
    }
  }

  const handlesubmit = () => {
    try {
      if (props.patientsData.id !== "" && props.patientsData.p_uhid !== "" && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
        setshow(true)
        setTimeout(async () => {
          const htmlPayload = document.getElementById("HRTListChartReportGenerateWrap").innerHTML

          const createNewAppointment = async () => {
            console.log(appointmentData)
            await dispatch(postAppointment(appointmentData))
          }
          createNewAppointment()

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: "",
              template_type: "HRT Chart",
            },
          }

          props.loaderchange(true)
          const patentDetails = postPrescriptionTemplate(payload)
          const response = await dispatch(patentDetails)
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false)
            navigate("/PatientView")
            Swal.fire({
              title: "Successful.",
              text: "Record added successful.",
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            })
          } else {
            props.loaderchange("false")
            props.popupalert("true")
            props.popuptext("Network went wrong, Please try after some time.")
            setTimeout(() => {
              props.popupalert("false")
            }, 2000)
          }
        }, 3000)
      } else {
        Swal.fire({
          title: "Error.",
          text: "Please enter valid patient id.",
          icon: "error",
          showConfirmButton: false,
          timer: 1500,
        })
      }
    } catch (error) {
      console.error("An error occurred:", error)
    }
  }

  return (
    <div id="HRTListChart">
      <div className="HRTListChartTemplate">
        <div className="" style={{ width: "100%", display: "block" }} id="patientInfo1">
          <div style={{ width: "100%" }}>
            <img
              className="header_image"
              src={headerimage || "/placeholder.svg"}
              style={{
                width: "100%",
                margin: "0 auto",
              }}
            />
          </div>
          <h4 style={{ display: "flex", justifyContent: "space-between" }}>
            HRT (Hormone Replacement Therapy) - ENDOMETRIAL PREPARATION SHEET
       
          </h4>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>

        <div className="detail">
          <div className="row mt-2">
            <h4 className="mt-4">PATIENT INFORMATION</h4>

            <div className="col-md-4">
              <ReportFormInputWithLabel
                label="Height :"
                name="height"
                value={formData.height}
                required={false}
                onChange={handleChange}
                inputClassName="show"
                endLabel="cm"
              />
            </div>

            <div className="col-md-4">
              <ReportFormInputWithLabel
                label="Weight :"
                name="weight"
                value={formData.weight}
                required={false}
                onChange={handleChange}
                inputClassName="show"
                endLabel="kg"
              />
            </div>
            <div className="col-md-4">
              <ReportFormInputWithLabel
                label="BMI :"
                name="bmi"
                value={bmiValue(formData.height, formData.weight)}
                required={false}
                onChange={handleChange}
                inputClassName="show"
                endLabel="kg/m2"
                disabled={true}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-4">
              <ReportFormInputWithLabel
                label="PR :"
                name="pr"
                value={formData.pr}
                required={false}
                onChange={handleChange}
                inputClassName="show"
                endLabel="bpm"
              />
            </div>
            <div className="col-md-6">
              <ReportFormInputWithLabel
                label="Blood Pressure (BP) :"
                name="bp"
                value={formData.bp}
                required={false}
                onChange={handleChange}
                inputClassName="show"
                endLabel="mmHg"
                minWidth="200px"
              />
            </div>
          </div>


          <h4 className="mt-4 mb-3">HRT CHART:</h4>
          {showTables.hrtChart && (
            <TemplateTable
              id="hrtChart"
              title=""
              headers={hrtChartHeaders}
              rows={hrtChartRows.map((row) => ({ ...row }))}
              onRowsChange={handleHrtRowsChange}
              enableActions={true}
              onNill={() => handleNill("hrtChart", setShowTables)}
            />
          )}


          <div className="d-flex align-items-start py-2" style={{ gap: "10px" }}>
            <label
              htmlFor="advice"
              className="fw-bold"
              style={{ whiteSpace: "nowrap", paddingTop: "6px", fontSize: "18px" }}
            >
              ADVICE:
            </label>
            <textarea
              className="Textarea"
              placeholder="Enter advice"
              id="advice"
              name="advice"
              value={formData.advice || ""}
              onChange={handleChange}
              rows="4"
              cols="100"
            />
          </div>

          <p className="pt-3" style={{ fontWeight: "600" }}>
            NEXT APPOINTMENT -{" "}
            <input
              name="nextAppointment"
              onChange={handleChange}
              type="date"
              className={`createTime ${show ? "hide" : "show"}`}
            />
          </p>

          <div className={`Footer ${show ? "hide" : "show"}`}>
            <button onClick={handlesubmit} className="Button_Create">
              Add Report
            </button>
          </div>
        </div>

        <div id="HRTListChartReportGenerate">
          <div id="HRTListChartReportGenerateWrap">
            <Headers />
            <p className="Dani"></p>
            <div
              className="patient"
              style={{
                border: "1px solid black",
                borderRadius: "10px",
                marginBottom: "10px",
              }}
            >
              <div className="nameToAgeContainer" style={{ display: "flex", marginBottom: "10px" }}>
                {renderReportfield(
                  "Patient Name :",
                  `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`,
                )}
                {renderReportfield("Patient ID :", props.patientsData.p_uhid)}
                {renderReportfield("Gender :", props.patientsData.gender)}
                {renderReportfield("Age :", props.patientsData.age)}
              </div>
            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
              <h4 style={{ fontWeight: 600, marginRight: "5px" }}>PATIENT INFORMATION</h4>
            </div>
            <div style={{ display: "flex", marginTop: "10px" }}>
              {renderReportfield("Height :", `${formData.height ? formData.height : ""} cm`, {
                styleSec: { margin: "0 10px 10px 10px", display: "flex" },
                styleLabel: labelStyles,
              })}
              {renderReportfield("Weight :", `${formData.weight ? formData.weight : ""} kg`, {
                styleSec: { margin: "0 10px 10px 10px", display: "flex" },
                styleLabel: labelStyles,
              })}
              {renderReportfield("BMI :", `${bmiValue(formData.height, formData.weight)} kg/m2`, {
                styleSec: { margin: "0 10px 10px 10px", display: "flex" },
                styleLabel: labelStyles,
              })}
              {renderReportfield("PR :", `${formData.pr ? formData.pr : ""} bpm`, {
                styleSec: { margin: "0 10px 10px 10px", display: "flex" },
                styleLabel: labelStyles,
              })}
              {renderReportfield("Blood Pressure (BP) :", `${formData.bp ? formData.bp : ""} mm Hg`, {
                styleSec: { margin: "0 10px 10px 10px", display: "flex" },
                styleLabel: labelStyles,
              })}
            </div>





          {showTables.hrtChart && (
            <>
            <div style={{ display: "flex", marginTop: "10px" }}>
              <h4 style={{ fontWeight: 600, marginRight: "5px" }}>HRT CHART</h4>
            </div>

            <div>
              <table
                style={{
                  marginBottom: "10px",
                  border: "1px solid black",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                <thead>
                  <tr>{hrtChartHeaders.map((ele, ind) => renderTableTH(ele.label))}</tr>
                </thead>
                <tbody>
                  {hrtChartRows.map((row, i) => (
                    <tr key={i}>
                      {renderTableTD(row.date)}
                      {renderTableTD(row.cd)}
                      {renderTableTD(row.tabProgynova)}
                      {renderTableTD(row.et)}
                      {renderTableTD(row.r)}
                      {renderTableTD(row.zone)}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </>
          )}

            <div style={{ display: "flex", marginBottom: "10px" }}>
              {renderReportfield("Advice :", `${formData.advice ? formData.advice : ""}`, {
                styleSec: { width: "100%", margin: "10px 0" },
              })}
            </div>

            <div style={{ marginTop: "10px" }}>
              {renderReportfield("Next Appointment : ", formData.nextAppointment?.split("-").reverse().join("-"))}
            </div>
            <p className="Dani"></p>
            <PrescriptionFooter />
          </div>
        </div>
      </div>
    </div>
  )
}
